import { render, staticRenderFns } from "./Infocard.vue?vue&type=template&id=1f1ca7c7&scoped=true&"
import script from "./Infocard.vue?vue&type=script&lang=js&"
export * from "./Infocard.vue?vue&type=script&lang=js&"
import style0 from "./Infocard.vue?vue&type=style&index=0&id=1f1ca7c7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f1ca7c7",
  null
  
)

export default component.exports